export default "__VITE_PUBLIC_ASSET__5f5fc2e9__"